import { default as ViewImageModal } from "./ViewImageModal";

const Modals = {
  ViewImageModal,
};

export default Modals;
